export default __webpack_public_path__ + "static/media/rectangle.a3756ff4.svg";